<template>
	<!-- 用户管理 -->
	<div>
		<el-tabs type="border-card">
			<el-tab-pane label="用户管理">
				<!-- <el-tabs type="border-card"> -->
				<el-form label-width="80px" :model="so">
					<el-form-item label="用户名">
						<el-input v-model="so.guanjianci" style="width: 80%;" size="medium"></el-input>
						<el-button size="medium"  @click="CSH">搜索</el-button>
					</el-form-item>
				</el-form>
				<el-divider></el-divider>
				<el-table :data="lie" stripe style="width: 100%">
					<el-table-column prop="yonghuming" label="用户名" width="180"> </el-table-column>
					<el-table-column prop="xingming" label="姓名" width="180"> </el-table-column>
					<el-table-column label="身份" width="180">
						<template slot-scope="shu">
							<el-button type="primary" size="small" v-if="shu.row.shenfen==1">超级管理员</el-button>
							<el-button type="success" size="small" v-else-if="shu.row.shenfen==2">代理人</el-button>
							<el-button type="success" size="small" v-else-if="shu.row.shenfen==3">管理员</el-button>
							<el-button type="success" size="small" v-else>操作员</el-button>
						</template>	
					</el-table-column>
					<el-table-column prop="address" label="状态" width="280">
						<template slot-scope="shu" v-if="shu.row.shenfen>1">
							<el-switch v-model="shu.row.zhuangtai" active-value="1" inactive-value="0" @change="Shenhe(shu.row)"></el-switch>
						</template>			
					</el-table-column>
					<el-table-column label="有效期限" width="180">
						<template slot-scope="shu" >
						    <div v-if="shu.row.shenfen>1">
								<div>{{shu.row.kaishishijian}}</div>
								<div>{{shu.row.jieshushijian}}</div>
							</div>
							<div v-else>永久</div>
						</template>
					</el-table-column>
					<el-table-column prop="zhuceshijian" label="注册时间" width="180"> </el-table-column>
					<el-table-column prop="address" label="操作">
						<template slot-scope="shu" >
							<el-button type="primary" size="small" @click="Mianbandakai(['xinzeng',shu.row])">编辑</el-button>
							<el-button type="success" size="small" @click="Mianbandakai(['quanxian',shu.row])"  v-if="shu.row.shenfen>1">权限</el-button>
							<el-button size="small" v-if="shu.row.shenfen>1" @click="Shanchu(shu.row)">删除</el-button>
						</template>		
					</el-table-column>
				</el-table>
				<el-pagination background layout="total,prev,pager,next,jumper" :total="zongshu" :page-size="so.jitiao" :current-page.sync="so.ye" @current-change="CSH" style="margin-top: 30px;">
				</el-pagination>
				<el-button type="danger" style="margin-top:20px ;" size="small" @click="Mianbandakai(['xinzeng',{shenfen:'4'}])">新增用户</el-button>
			
			</el-tab-pane>
		</el-tabs>
		<el-drawer title="新增用户" :visible.sync="mianban.xinzeng" size="30%">
			<el-form ref="so" :model="mianban_shu" label-width="80px" style="margin-left: 80px;">
				<el-form-item label="账号" style="width: 91%;" label-width="100px">
					<el-input v-model="mianban_shu.yonghuming" />
				</el-form-item>
				<el-form-item label="密码" style="width: 91%; " label-width="100px">
					<el-input v-model="mianban_shu.mima"  type="password" />
				</el-form-item>
				<el-form-item label="姓名" style="width: 91%; " label-width="100px">
					<el-input v-model="mianban_shu.xingming" />
				</el-form-item>
				<el-form-item label="有效期限" label-width="100px" v-if="mianban_shu.shenfen>1">
					<div class="block">
						<el-date-picker style="width: 90%;" type="date" placeholder="选择日期" v-model="mianban_shu.jieshushijian"></el-date-picker>
					</div>
				</el-form-item>
				<el-form-item label="管理员身份" label-width="100px" v-if="mianban_shu.shenfen>1">
					<el-select v-model="mianban_shu.shenfen" placeholder="请选择状态" style="width: 90%;">
						<el-option label="管理员" value="3"></el-option>
						<el-option label="操作员" value="4"></el-option>						
					</el-select>
				</el-form-item>

				<!-- <el-form-item label="绑定公众号" label-width="100px">
					<el-select v-model="mianban_shu.danyuan" placeholder="请选择公众号" style="width: 90%;">
						<el-option label="码元" value="1"></el-option>
					</el-select>
				</el-form-item> -->
				<el-form-item label-width="100px">
					<Tijiao @click="Mianban_post('xinzeng')"></Tijiao>
				</el-form-item>
			</el-form>
		</el-drawer>
		<!-- 权限 -->
		<el-drawer title="分配权限":visible.sync="mianban.quanxian"  size="30%" >		
			<div style="overflow-y: scroll; height: 90vh; padding-bottom: 40px;" v-if="mianban.quanxian">
				<ul class="xuanul" >
					<li v-for="l in mianban_shu">
						<div class="xuankuan">
							<el-checkbox v-model="l.xuanzhong"  :true-label="1" :false-label="0">{{l.ming}}</el-checkbox>
						</div>
						<ol class="quanxian2">
							<li class="quanxian2li" v-for="ll in l.haizi">
								<div class="xuankuan">
									<el-checkbox  v-model="ll.xuanzhong"  :true-label="1" :false-label="0">{{ll.ming}}</el-checkbox>
								</div>
							</li>
						</ol>
					</li>			
				</ul>
				<Tijiao @click="Mianban_post('quanxian')" wenzi="提交" type="danger"></Tijiao>
			</div>
		</el-drawer>		
	</div>
</template>
<script>
	let that;
	export default {
		data() {
			return {				
				zongshu: 0,				
				so: {ye: 1,jitiao: 10},
				lie:[],			
				mianban: {					
					xinzeng: false,
					quanxian:false,
				},
				mianban_shu: [],
				quanxian_lie:[]
			};
		},
		created() {
			that = this;
			this.CSH();
			this.Quanxian();
		},
		methods: {
			CSH(){				
				this.$post('k=guanliyuan',that.so,function(s) {
					that.lie = s.shu.lie;
					that.zongshu = Number(s.shu.zongshu);
				});
			},
			Quanxian(){
				this.$post('k=guanliyuan&c=quanxian',function(s) {
					that.quanxian_lie = s.shu;					
				});
			},
			Mianbandakai(e) {
				that.mianban[e[0]] = true;
				that.mianban_shu=[];
				if(e['0']=='quanxian'){
					this._id=e[1].id;
					var shu= e[1].quanxian || {};				
					that.mianban_shu=JSON.parse(JSON.stringify(that.quanxian_lie));
					for(var i in that.mianban_shu){
						if(shu[i] && shu[i].xuanzhong==1){
							that.mianban_shu[i].xuanzhong=Number(1);							
						}
						if(that.mianban_shu[i].haizi){
							for(var l in that.mianban_shu[i].haizi){
								if(shu[i] && shu[i].haizi && shu[i].haizi[l] && shu[i].haizi[l].xuanzhong==1){
									that.mianban_shu[i].haizi[l].xuanzhong=Number(1);
								}
							}
						}
						
					}				
				}else{
					that.mianban_shu = e[1] || [];
				}
			},
			Mianban_post(e) {
				if (e == 'xinzeng') {
					this.$post('k=guanliyuan&c=Xiugai', that.mianban_shu, function(s) {
						that.$xiaoxi(s.shu);
						if (s.shi == 1) {
							that.CSH();
						}
					});
				} else if (e == 'quanxian') {					
					this.$post('k=guanliyuan&c=Xiugai_quanxian',{quanxian:that.mianban_shu,id:that._id}, function(s) {
						that.$xiaoxi(s.shu);
						if (s.shi == 1) {
							that.CSH();
						}
					});
				}
				that.mianban[e] = false;
			},
			Shenhe(e){
				this.$post('k=guanliyuan&c=Xiugai',{id:e.id,zhuangtai:e.zhuangtai}, function(s) {
					that.$xiaoxi(s.shu);
					if (s.shi == 1) {
						that.CSH();
					}
				});
			},
			Shanchu(e){
				this.$post('k=guanliyuan&c=shandiao',{id:e.id}, function(s) {
					that.$xiaoxi(s.shu);
					if (s.shi == 1) {
						that.CSH();
					}
				});
			}
		}
	}
</script>

<style scoped>
	.el-form-item__label {
		width: 100px !important;
	}

	.biaoti {
		display: block;
		width: 100%;
		text-indent: 10px;
		margin-bottom: 16px;
		font-size: 20px;
		color: #788188;
	}

	.input {
		margin-left: 20px;
		width: 98%;
	}

	.tishi {
		/* margin-left: 20px; */
		display: block;
		color: #737373;
	}

	.demo-drawer__footer {
		margin-left: 48px;
		margin-top: 20px;
	}

	.tishi2 {
		color: #FF0000;
	}

	.xuankuan {
		display: block;
		margin: 5px 0;
		padding: 0px 10px;
		height: 48px;
		line-height: 48px;
		text-decoration: none;
		border: 1px solid #ebebeb;
		background: #fff;
		-webkit-border-radius: 3px;
		border-radius: 3px;
	}

	ul li {
		list-style: none;
	}

	.xuanul {
		width: 50%;
		margin-bottom: 40px;
	}

	.quanxian2 {
		display: block;
		position: relative;
		list-style: none;
		padding-left: 30px;
	}

	.quanxian3 {
		display: block;
		position: relative;
		list-style: none;
		padding-left: 60px;
	}

	.quanxian2li {
		margin-bottom: 5px;
	}

	/* .el-drawer__body {
	 
		} */
</style>
